var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('el-image',{staticClass:"empty-img",attrs:{"src":_vm.currentImg,"fit":"contain"}}),_c('div',{staticClass:"empty-tips"},[_vm._v(_vm._s(_vm.tips))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }